import { render, staticRenderFns } from "./work_item_display_settings_user_preferences.vue.js?vue&type=template&id=29346860&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_display_settings_user_preferences.vue?vue&type=template&id=29346860&vue3"
import script from "./work_item_display_settings_user_preferences.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_display_settings_user_preferences.vue?vue&type=script&lang=js&vue3"
export * from "./work_item_display_settings_user_preferences.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_display_settings_user_preferences.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports